module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "viewBox": "0 0 628 598",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#1E7BBB"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "opacity": "0.5",
      "x": "0",
      "y": "0",
      "width": "1.03857567",
      "height": "596.16559"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Top",
      "x": "0",
      "y": "0",
      "width": "49.851632",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "128.927445",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "61.2933754",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "26.5076236",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "95.1104101",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "163.801262",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "232.492114",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "301.182965",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "368.817035",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "197.618297",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "266.309148",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "335",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "403.690852",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "437.507886",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "472.381703",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "506.198738",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "541.072555",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "574.88959",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Bottom",
      "x": "0",
      "y": "594.968454",
      "width": "49.851632",
      "height": "1.05678233"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4e7af32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/hatch_bg.vue
// module id = 663
// module chunks = 1